module.exports = __webpack_public_path__ + "img/xtts_bg.2ae2bc1b.png";